{
  "messages": {
    "networkError": "Une erreur réseau s'est produite. Si le problème persiste, veuillez nous contacter.",
    "appointmentUpdatedValidationFailed": "Le rendez-vous a été mis à jour, mais la validation externe a échoué.",
    "appointmentCreatedValidationFailed": "Le rendez-vous a été créé, mais la validation externe a échoué.",
    "validationErrorDetail": "<br /> Erreur de validation : {error}"
  },
  "titles": {
    "warehouseRuleFailed": "Échec de la règle de l'entrepôt",
    "validationServerError": "Erreur du serveur de validation",
    "appointmentUpdatedWithValidationError": "Rendez-vous mis à jour avec une erreur de validation",
    "appointmentCreatedWithValidationError": "Rendez-vous créé avec une erreur de validation"
  }
}
